import { render } from "./InheritanceExplainer.vue?vue&type=template&id=51e92ab6&scoped=true"
import script from "./InheritanceExplainer.vue?vue&type=script&lang=js"
export * from "./InheritanceExplainer.vue?vue&type=script&lang=js"

import "./InheritanceExplainer.vue?vue&type=style&index=0&id=51e92ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e92ab6"]])

export default __exports__